
import React from 'react';
import ZNetwork from "./znetwork";
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZUtil from "./zutil";
import PleaseStandBy from "./PleaseStandBy";
import ZooNoResultsFound from "./ZooNoResultsFound";
import ZooTabs from "./ZooTabs";
import AMCConstants from "./AMCConstants";
import { ROUTER } from './AMCRouter';
import { MainMenuItem } from './zoo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faStar, faThumbsUp, faEye, faRunning, faComments, faCogs, faFlask, faChild, faBrain, faCheck } from '@fortawesome/free-solid-svg-icons'
import { KINDS } from './AMCConstants';
import { APP } from "./App.js";
import AMC from './AMC';

export default class ZooLeaderboardsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	// members|usecases|kind + [ / + metric popular|liked|...]
	// user_uri + [ / + metric ]
	componentDidMount() {
		let { path } = this.props;
		let kind = null, metric = null, user_uri = null;
		APP.setTitle("Leaderboards");
		AMC.track(AMCConstants.LEADERBOARDS_TRACKING_URI);
		if (path) {
			let subpaths = path.split("/");
			if (subpaths[0] === "members" || subpaths[0] === "usecases" || KINDS[subpaths[0]]) {
				kind = subpaths[0];
			} else {
				user_uri = subpaths[0];
			}
			metric = subpaths[1]
		}
		if (!kind) {
			kind = "service";
		}

		ZLog.debug("ZooLeaderboardsPage.kind=" + kind);
		ZLog.debug("ZooLeaderboardsPage.metric=" + metric);
		this.setState({ kind: kind, user_uri: user_uri, metric: metric });
		let leaderboards = ZProps.get("leaderboards" + (user_uri ? ":" + user_uri : ""));
		if (leaderboards) {
			this.setState({ leaderboards: leaderboards, groups_loaded: true, stats_loaded: true });
			return;
		}
		this.setState({ kind: kind, user_uri: user_uri, metric: metric });
		ZNetwork.get("leaderboards", user_uri, (err, boards) => {
			if (err || !boards || boards.length === 0) {
				ZLog.error("Unable to fetch leaderboards: " + err);
				this.setState({ leaderboards: [], groups_loaded: true });
			} else {
				// perhaps overly optimisitc that rest of data will load sucessfully
		 		ZProps.set("leaderboards" + (user_uri ? ":" + user_uri : ""), boards);
				let groups = [];
				let leader_uris = [];
				for (let i = 0; i < boards.length; ++i) {
					let leaders = boards[i].leaders;
					for (let j = 0; j < leaders.length; ++j) {
						leader_uris.push(leaders[j].uri);
						if (leaders[j].group) {
							groups.push(leaders[j].group);
						}
					}
				}
				if (groups.length > 0) {
					groups = ZUtil.uniq(groups);
					ZNetwork.post("users", null, null, { groups: groups }, (err, groups) => {
						if (err || !groups || groups.length === 0) {
							ZLog.error("Unable to fetch leader owners: " + err);
							this.setState({ leaderboards: [], groups_loaded: true });
						} else {
							for (let i = 0; i < groups.length; ++i) {
								// if user still with us and not something like 'guest'
								if (groups[i]) {
									ZProps.set(groups[i].uri, groups[i]);
								}
							}
							this.setState({ groups_loaded: true });
						}
					});
				} else {
					this.setState({ groups_loaded: true });
				}

				leader_uris = ZUtil.uniq(leader_uris);
				// Do we really need to update stats?
/*
				ZNetwork.post("stats", null, null, { uris: leader_uris }, (err, stats) => {
					if (err || !stats || stats.length === 0) {
						ZLog.error("Unable to fetch leader stats: " + err);
						this.setState({ leaderboards: [], groups_loaded: true, stats_loaded: true });
					} else {
						for (let i = 0; i < leader_uris.length; ++i) {
							ZProps.set(leader_uris[i] + ".stats", stats[i]);
						}
						this.setState({ stats_loaded: true });
					}
					
				});
*/
				this.setState({ leaderboards: boards });
			}
		});
	}
	componentWillUnmount() {
		APP.setTitle(null);
	}
	onSelectTab(label) {
		if (label === "more...") {
			this.setState({ more: !this.state.more });
		} else {
			let kind = label.substring(0, label.length -1);
			ROUTER.softPushRoute(AMCConstants.LEADERBOARDS_URI + "/" + kind);
			this.setState({ kind: kind });
		}
	}
	render() {
		let { leaderboards, groups_loaded, kind, metric, more } = this.state;
		//if (!leaderboards || !stats_loaded || !groups_loaded) {
		if (!leaderboards || !groups_loaded) {
			return <PleaseStandBy />;
		}

		let boards = []
		let name_to_leaderboard_map = {};
		let target_kind = kind;
		let target_metric = metric;
		if (!target_kind) {
			target_kind = "service";
			target_metric = "mostpopular";
		}
		leaderboards.forEach(x => { name_to_leaderboard_map[x.name] = x });

		if (target_kind === "usecase") {
		} else if (target_kind === "member") {
			// Members TODO
			const LEADERBOARD_NAME_TO_DISPLAY_NAMES = {
				MOSTPOPULAR: "Top overall",
				MOSTKUDOS: "Most kudos",
			}
			let categories = leaderboards.map(x => x.name);

			for (let i = 0; i < categories.length; ++i) {
				let name = categories[i];
				let leaderboard = name_to_leaderboard_map[name];
				if (leaderboard.leaders.length === 0) {
					//continue;
				}
				let displayname = LEADERBOARD_NAME_TO_DISPLAY_NAMES[name.split(":")[1]];
				let metric = name.substring(0, name.lastIndexOf(":"));
				boards.push( <ZooLeaderboard key={displayname} leaderboards={leaderboards} name={name} displayname={displayname} leaderboard={leaderboard} metric={metric} kind={target_kind} /> );
			}
		} else {
			// Things
			const LEADERBOARD_NAME_TO_DISPLAY_NAMES = {
				MOSTPOPULAR: "Most popular",
				MOSTUSEDS: "Most used",
				MOSTRUNS: "Most run",
				MOSTVISITS: "Most visited",
				MOSTSTARS: "Most starred",
				MOSTLIKES: "Most liked",
				MOSTCOMMENTS: "Most commented",
				MOSTCLONES: "Most cloned",
				MOSTFREAKOUTS: "Most freakouts",
				TRENDING: "Trending",
			}
			let postfix = ":" + target_kind;
			let prefix = target_metric ? "THING:" + target_metric.toUpperCase() : null;
			let categories = leaderboards.filter( x => x.name.endsWith(postfix) ).map(x => x.name);
//			let categories = leaderboards.filter( x => { console.log("x.name=" + x.name +",postifx=" + postfix); return x.name.endsWith(postfix) } ).map(x => x.name);
			for (let i = 0; i < categories.length; ++i) {
				let name = categories[i];
				let leaderboard = name_to_leaderboard_map[name];
				if (leaderboard.leaders.length === 0) {
					//continue;
					continue;
				}
				if (prefix && !name.startsWith(prefix)) {
					continue;
				}
				if (!name.endsWith(postfix)) {
					continue;
				}
				let displayname = LEADERBOARD_NAME_TO_DISPLAY_NAMES[name.split(":")[1]];
				let metric = name.substring(0, name.lastIndexOf(":"));
				boards.push( <ZooLeaderboard key={displayname} leaderboards={leaderboards} name={name} displayname={displayname} leaderboard={leaderboard} metric={metric} kind={target_kind} /> );
			}
		}
		let tabs = ["services", "datasets", "datasources", "trainers", "predictors", "more..."];
		if (tabs.indexOf(kind + "s") === -1) {
			tabs.splice(3, 0, kind + "s");
		}
		// let kinds = Object.keys(KINDS).filter( k => k !== "service" && k !== "datasource" && k !== "algorithm" );
		let kinds = leaderboards.filter(b => b.leaders.length > 0).map(b => b.name.split(":")[2]);
		kinds = ZUtil.uniq(kinds).filter( k => k !== "service" && k !== "dataset" && k !== "datasource" && k !== "trainer" && k !== "predictor" );
		let menu = more ?
			<div className="ZooLeaderboardPageMenu">
				{ kinds.map( kind => {
					return <MainMenuItem label={kind} fonticon={<FontAwesomeIcon icon={KINDS[kind].icon} />} link={AMCConstants.LEADERBOARDS_URI + "/" + kind} />
				} ) }
			</div>
			: '';
				
		return (
			<div className="ZooLeaderboardPage"> 
				<ZooTabs tabs={tabs} selected={kind + "s"} onSelectTab={this.onSelectTab.bind(this)} />
				{menu}
				{boards.length === 0 ? <ZooNoResultsFound /> : boards}
				
			</div>
		);
	}
}


class ZooLeaderboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { leaderboards, name, displayname, leaderboard, metric, kind } = this.props;

		let leaders = leaderboard.leaders;
//		let boards_for_other_kinds_this_metric = leaderboards.filter( x => { 
//			return x.name.startsWith(metric) && x.leaders.length > 0 && x.name !== name 
//		});
		let boards_for_other_metrics_this_kind = leaderboards.filter( x => { 
			return x.name.endsWith(kind) && x.leaders.length > 0 && x.name !== name 
		});
		let widgets = [];
		let rank = leaderboard.offset;
		widgets.push(<div key={"header:" + displayname} className="ZooLeaderboardHeader"><h1>{displayname}: {kind}s</h1></div>);
		for (let j = 0; j < leaders.length; ++j) {
			let leader = leaders[j];
			widgets.push(<ZooSearchResultLineItem key={leader.uri + "-" + j} item={leader} metric={metric} rank={rank + j + 1} />);
		}
		return (
			<div className="ZooLeaderboardBoard">
				<div className="ZooLeaderboardLeaders">{widgets}</div>
				<div className="ZooLeaderboardsLinks">
					<ZooLeaderboardsOtherMetricsThisKind boards={boards_for_other_metrics_this_kind} kind={kind} />
				</div>
			</div>
		);
	}
}
export class ZooSearchResultLineItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { item, rank, metric, description, onClick } = this.props;

		let link = "/zoo/" + item.uri;
		let stats = item; 
if (false) {
let _realtimestats = ZProps.get(item.uri + ".stats");
Object.keys(_realtimestats).forEach( stat => {
	if (["updated_at", "uri"].indexOf(stat) === -1 && item[stat] !== _realtimestats[stat]) {
		console.error("Leaderboard stat is stale: " + stat + ". Was=" + item[stat] +", now=" + _realtimestats[stat]);
	}
});
}
if (!item.group) {
// throw new Error("No group for item: " + item.uri);
// bad models when 1st embedding them
item.group = "?";
}
		//let framework = ["trainer", "tester", "predictor"].indexOf(item.kind) !== -1 ? item.framework : null;
		let framework = (item.kind === "service" ? (item.framework ? [item.framework] : []).concat(item.stacks) : (item.dependencies || [])).join(", ");
		let owner = ZProps.get(item.group);
		return (
				<a key={link} tabIndex={rank} className="ZooSearchResultLineItem ClearFix" onClick={e => { e.preventDefault(); onClick ? onClick(item) : ROUTER.pushRoute(link); return false; } } href={onClick ? null : link} >
					<div className="ZooSearchResultLineItemRank">{rank || ""}</div>
					{AMC.getNodeThumbElement(item, "ZooSearchResultLineItemThumb")}
					<div className="ZooSearchResultLineItemContent">
						<div className="ZooSearchResultLineItemName">{item.name || item.uri.split("/")[2]}{framework ? <span className="ZooSearchResultLineItemFrameworks">{" (" + framework + ")"}</span> : ""}</div>
						{ description ? <div className="ZooSearchResultLineItemDesc">{description}</div> : '' }
						{ stats ? <div>
							{ description ? <div className="ZooSearchResultLineItemUserPrefix"><ZooSearchResultLineItemOwner user={owner} item={item} stats={{}} /></div> : '' }
							<ZooSearchResultLineItemStats item={item} stats={stats} metric={metric} />
						</div> : '' }
					</div>
					{ description ? "" : <ZooSearchResultLineItemOwner user={owner} item={item} stats={{}} /> }
				</a>
		)
	}
}
export class ZooSearchResultLineItemStats extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { item, stats, human, metric, included } = this.props;
		if (human) {
			return (
				<div className="ZooSearchResultLineItemStats">
					<span><FontAwesomeIcon icon={faStar} /> {stats.kudos}</span>

				</div>
			)
		}
		let classNames = {};
		if (metric) {
			metric = metric.toLowerCase().split(":")[1].substring(4);
			classNames[metric] = "ZooSearchResultLineItemStatsFeatured";
		}
		let METRICS = ["stars", "likes", "useds", "runs", "comments", "clones", "visits", "freakouts", "pricing", "deployed" ];
		for (let i = 0; i < METRICS.length; ++i) {
//			if (metric !== METRICS[i] && stats[METRICS[i]]) {
			if (stats[METRICS[i]]) {
				classNames[METRICS[i]] = (classNames[METRICS[i]] || "") + " ZooSearchResultLineItemStatsSignificant";
			}
			if (included && included.indexOf(METRICS[i]) === -1) {
				classNames[METRICS[i]] = "ZooSearchResultLineItemStatsHidden";
			}
		}
//console.log("----------" );
//console.log("uri: " + item.uri);
//console.log("trained: " + item.trained);
//console.log("deployed: " + item.deployed);
//console.log("state: " + item.state);
		return (
			<div className="ZooSearchResultLineItemStats">
				<span className={classNames.stars}><FontAwesomeIcon icon={faStar} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.stars || 0)}</span></span>
				<span className={classNames.likes}><FontAwesomeIcon icon={faThumbsUp} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.likes || 0)}</span></span>
				<span data-tooltip="Useds" title="Used" className={classNames.useds}><FontAwesomeIcon icon={faCogs} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.useds || 0)}</span></span>
				<span data-tooltip="Runs" title="Runs" className={classNames.runs}><FontAwesomeIcon icon={faRunning} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.runs || 0)}</span></span>
				<span data-tooltip="Comments" title="Comments" className={classNames.comments}><FontAwesomeIcon icon={faComments} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.comments || 0)}</span></span>
				<span data-tooltip="Clones" title="Clones" className={classNames.clones}><FontAwesomeIcon icon={faFlask} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.clones || 0)}</span></span>
				<span data-tooltip="Visits" title="Visits" className={classNames.visits}><FontAwesomeIcon icon={faEye} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.visits || 0)}</span></span>
				<span data-tooltip="Freakouts" title="Freakouts" className={classNames.freakouts}><FontAwesomeIcon icon={faChild} /><span className="ZooSearchResultLineItemStatsValue"> {ZUtil.toShortCount(stats.freakouts || 0)}</span></span>
				{item.pricing ? <span data-tooltip="Pricing" title="Pricing" className={classNames.pricing}><FontAwesomeIcon icon={faDollarSign} /><span className="ZooSearchResultLineItemStatsValue"> {item.pricing || "0.00"}</span></span> : '' }
				{item.kind === "service" && item.trained ?  <span data-tooltip="Trained" title="Trained" className={classNames.trained}><FontAwesomeIcon icon={faBrain} /><span className="ZooSearchResultLineItemStatsValue"> </span></span> : '' }
				{item.kind === "service" && item.deployed ?  <span data-tooltip="Deployed" title="Deployed" className={"ZooSearchResultLineItemStatsDeployed" + classNames.deployed}><FontAwesomeIcon icon={faCheck} /><span className="ZooSearchResultLineItemStatsValue"> </span></span> : '' }
			</div>
		)
	}
}
class ZooSearchResultLineItemOwner extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { user, item } = this.props;
		if (!user) {
			return (
				<div className="ZooSearchResultLineItemOwner">
					<div className="ZooSearchResultLineItemOwnerThumb">{AMC.genThumbFromName(item.group)}</div>
					<div className="ZooSearchResultLineItemOwnerStats">
						<span>{item.group}</span>
					</div>
				</div>
			);
		}
		return (
			<div className="ZooSearchResultLineItemOwner">
				<div className="ZooSearchResultLineItemOwnerThumb">{AMC.getUserThumbElement(user)}</div>
				<div className="ZooSearchResultLineItemOwnerStats">
					<span>{user.uri}</span>
{/*					<span data-tooltip="Visits"><FontAwesomeIcon icon={faCrown} /> {stats.kudos}</span> */}
					<span>{user.tagline}</span>
				</div>
			</div>
		)
	}
}
/*
class ZooLeaderboardsOtherKindsThisMetric extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { boards, metric } = this.props;
		let kinds = boards.filter(b => b.leaders.length > 0).map(b => b.name.split(":")[2]);
		metric = metric.toLowerCase().split(":")[1];
		let links = kinds.map( (k, index) => {
ZLog.log("boards[index]", { board: boards[index] });
			let link = "/leaderboards/" + k + "/" + metric;
			return <a className="ZooLeaderboardsBoardLink" key={k} href={link} onClick={ROUTER.pushRoute.bind(ROUTER, link)}>{k + "s"}</a>
		});
		return links;
	}
}
*/
class ZooLeaderboardsOtherMetricsThisKind extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { boards, kind } = this.props;
		let metrics = boards.filter(b => b.leaders.length > 0).map(b => b.name.split(":")[1].toLowerCase());
		let links = metrics.map( (m, index) => {
			let link = "/leaderboards/" + kind + "/" + m;
			return <a className="ZooLeaderboardsBoardLink" key={m} href={link} onClick={ROUTER.pushRoute.bind(ROUTER, link)}>{m.replace("most", "most ")}</a>
		});
		return links;
	}
}



// WEBPACK FOOTER //
// ./src/ZooLeaderboardsPage.js